import { render, staticRenderFns } from "./QuilityRxCardsSentDrilldown.vue?vue&type=template&id=2e68e32d&scoped=true&"
import script from "./QuilityRxCardsSentDrilldown.vue?vue&type=script&lang=js&"
export * from "./QuilityRxCardsSentDrilldown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e68e32d",
  null
  
)

export default component.exports